import { IDictionaryItems } from '@/.generated';
import ImageWrapper from '@/helpers/Wrappers/ImageWrapper/ImageWrapper';
import { toEnhancedImage } from '@/utils/image-utils';
import PlainTextWrapper from '@/helpers/Wrappers/PlainTextWrapper/PlainTextWrapper';
import { desktopHeaderVariants } from '../Header.styles';

type HeaderIdentifierLegendProps = {
  globalLabels: Partial<IDictionaryItems>;
};

export const HeaderIdentifierLegend = ({ globalLabels }: HeaderIdentifierLegendProps) => {
  const { identifierLegend, identifierLegendItem, identifierIcon } = desktopHeaderVariants();

  const englishOnlyIcon = globalLabels.english_only_identifier_icon;

  const hasEnglishOnlyIcon = !!englishOnlyIcon?.url;

  return (
    <div className={identifierLegend()}>
      <span className={identifierLegendItem()}>
        <i className="fa-solid fa-arrow-up-right text-secondary"></i>
        <PlainTextWrapper
          content={`= ${globalLabels.external_link_identifier_label}`}
          tag="i"
          cslpAttribute={globalLabels.$?.external_link_identifier_label}
        />
      </span>
      {hasEnglishOnlyIcon && (
        <span className={identifierLegendItem()}>
          <ImageWrapper
            image={toEnhancedImage(englishOnlyIcon, {
              fallbackWidth: 16,
              fallbackHeight: 12,
              cslp: globalLabels.$?.english_only_identifier_icon,
            })}
            alt={englishOnlyIcon!.title ?? ''}
            wrapperClassName="w-fit h-3"
            imageClassName={identifierIcon()}
          />
          <PlainTextWrapper
            content={`= ${globalLabels.english_only_identifier_label}`}
            tag="i"
            cslpAttribute={globalLabels.$?.english_only_identifier_label}
          />
        </span>
      )}
    </div>
  );
};
